module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-97231c8d97356a6c3653201db963b7f9.png";